"use client";

import clsx from "clsx";
import Image from "next/image";

interface TypingIndicatorProps {
  className?: string;
  senderName?: string;
  senderIcon?: string;
  showSender?: boolean;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  className,
  senderName = "Gail",
  senderIcon = "/icons/gail2-icon-black.svg",
  showSender = true,
}) => {
  return (
    <div className={clsx("max-w-[80%]", className)}>
      {showSender && (
        <div className="mb-2">
          <Image
            src={senderIcon}
            alt={`${senderName} Icon`}
            width={16}
            height={16}
            className="inline-block mr-2"
          />
          <span className="font-bold align-middle text-sm">• {senderName}</span>
        </div>
      )}
      <div className="text-sm leading-relaxed">
        <span className="inline-block animate-pulse">▋</span>
      </div>
    </div>
  );
};

export default TypingIndicator;
